import React, { useEffect, useState } from "react";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import SocialHandles from "../SocialHandles/SocialHandles";
import leftarrow from "../../Assets/icons/arrowrleft.svg";
import { getArticleById, getArticleByCategory } from "./_request";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ArticleTableeghat = () => {
  const [article, setArticle] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const navigate = useNavigate();
  const [copyStatus, setCopyStatus] = useState(""); // State for copy feedback
  // const [activeCategory, setActiveCategory] = useState('حصولِ علم'); // State to track active category

  // const categories = ['حصولِ علم', 'تعارف امامؑ میں سعی', 'غوروفکر']; // Array of categories

  useEffect(() => {
    const getArticles = async () => {
      setLoading(true);
      try {
        const response = await getArticleById(id);
        if (response.Result) {
          const data = response.Article;
          console.log("Article Data: ", response.Article);
          setArticle(data);

          // Now fetch related articles by category
          if (data.category) {
            const relatedRes = await getArticleByCategory(data.category.trim());
            if (relatedRes?.Articles) {
              const filtered = relatedRes.Articles.filter(
                (a) => String(a.id) !== String(id),
              ) // Ensure type-safe comparison
                .sort((a, b) => new Date(b.create_dt) - new Date(a.create_dt)) // latest first
                .slice(0, 3); // only 3
              setRelatedArticles(filtered);
            }
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getArticles();
  }, [id]);

  // function formatDate(isoString) {
  //   const date = new Date(isoString);

  //   const day = date.getDate();
  //   const year = date.getFullYear();

  //   const monthNames = [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ];
  //   const month = monthNames[date.getMonth()];

  //   return `${day} ${month}, ${year}`;
  // }

  const breadCrumbs = () => {
    const c = article.category?.trim();

    const muhasbaCategories = [
      "نماز شب",
      "نماز صبح و سحر خیزی",
      "قرآن و دعا",
      "ورزش",
      "نظم ٹائم ٹیبل",
      "غور و فکر",
      "مطالعہ و حصول علم",
      "تعلیم اہل خانہ و مومنین",
      "صدقہ",
      "معرفت امام زمانہ علیہ السلام",
      "تعارف امام میں سعی",
      "احسان به والدین صله رحم",
      "امداد مؤمنین",
      "ایفائے عہد",
      "امر معروف و نهی از منکر",
      "مستحب روزه",
      "نامحرم پر نگاہ سے اجتناب",
      "غیبت و تہمت سے دوری",
      "جھوٹ ونفاق سے پر ہیز",
      "بد اخلاقی پخش گوئی سے اجتناب",
      "لہو ولعب سے پر ہیز غضب و غصہ سے دوری",
      "ریا کاری سے اجتناب",
      "حد سے پر ہیز",
    ];

    const handleCategoryClick = (category) => {
      navigate("/tazakurat", { state: { selectedCategory: category } });
    };

    if (muhasbaCategories.includes(c)) {
      return (
        <>
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(null)}
          >
            نور ڈائری
          </p>
          <img src={leftarrow} alt="img" />
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(null)}
          >
            محاسبہ
          </p>
          <img src={leftarrow} alt="img" />
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(c)}
          >
            {c}
          </p>
          <img src={leftarrow} alt="img" />
          <p className="text-primary">{article.title}</p>
        </>
      );
    } else if (c === "Muharram" || c === "ayam e fatmiya") {
      return (
        <>
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(null)}
          >
            میگزین
          </p>
          <img src={leftarrow} alt="img" />
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(c)}
          >
            {c}
          </p>
          <img src={leftarrow} alt="img" />
          <p className="text-primary">{article.title}</p>
        </>
      );
    } else if (c === "yaad e imam") {
      return (
        <>
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(null)}
          >
            نور ڈائری
          </p>
          <img src={leftarrow} alt="img" />
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(null)}
          >
            یادِ امامؑ
          </p>
          <img src={leftarrow} alt="img" />
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(c)}
          >
            {c}
          </p>
          <img src={leftarrow} alt="img" />
          <p className="text-primary">{article.title}</p>
        </>
      );
    } else {
      return (
        <>
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(null)}
          >
            نور ڈائری
          </p>
          <img src={leftarrow} alt="img" />
          <p
            className="font-normal hover:text-primary cursor-pointer transition-all duration-300"
            onClick={() => handleCategoryClick(c)}
          >
            {c}
          </p>
          <img src={leftarrow} alt="img" />
          <p className="text-primary">{article.title}</p>
        </>
      );
    }
  };
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleCopyArticle = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopyStatus("لنک کاپی ہو گیا!");
      setTimeout(() => setCopyStatus(""), 2000);
    } catch {
      setCopyStatus("کاپی کرنے میں ناکامی!");
      setTimeout(() => setCopyStatus(""), 2000);
    }
  };
  const handleViewDetail = async (id) => {
    navigate(`/tableeghat/${id}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }

  return (
    <>
      <title>{article.title} | نور ڈائری</title>
      <meta property="og:title" content={article.title} />
      <meta
        property="og:description"
        content={
          article.metaDescription ||
          article.excerpt ||
          stripHtml(article.content).slice(0, 160)
        }
      />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content="article" />
      <meta name="twitter:title" content={article.title} />
      <meta
        name="twitter:description"
        content={
          article.metaDescription ||
          article.excerpt ||
          stripHtml(article.content).slice(0, 160)
        }
      />
      <Header />
      <div
        dir="rtl"
        className="bg-white min-h-screen w-full px-5 sm:px-10 md:px-16 lg:px-20 text-black text-center font-nastaleeqRegular font-normal pt-10 mb-6"
      >
        <div className="w-full lg:px-[246px] gap-12">
          {/* Breadcrumb */}
          <div className="p-[10px] rounded-lg bg-primaryBG w-fit flex gap-2 items-center mb-4 text-black">
            {breadCrumbs()}
          </div>

          {/* Two-column layout */}
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Right Column (2/3 width) */}
            <div className="w-full">
              <div className="flex flex-col gap-9 border-b-[1px] mb-4">
                {/* Article Image and Title */}
                <div className="bg-primaryBG w-full h-[100px] lg:h-[200px] flex flex-col items-center justify-center relative rounded-3xl">
                  <div className="flex flex-col gap-[10px] lg:gap-[20px] w-full bg-blend-color-blur p-4 inset-0 backdrop-blur-lg">
                    <p className="text-primary text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-nastaleeqKasheeda">
                      {" "}
                      {article.title}
                    </p>
                    <ul className="text-black list-disc flex gap-8 lg:gap-10 pr-4">
                      {article?.read_min && (
                        <li>{article.read_min}منٹ پڑھنے کا وقت</li>
                      )}
                      <li>
                        <p dir="ltr">
                          {article.article_type}-{article?.yearData?.year}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Article Content */}
                <div>
                  <div
                    className="w-full text-right text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqRegular group"
                    dangerouslySetInnerHTML={{ __html: article.content }}
                  />
                </div>
                <div className="bg-gradient-to-r from-cyan-500 to-primary rounded-xl p-5 hidden lg:flex flex-col lg:flex-row text-white justify-between items-start lg:items-center mb-4">
                  <p className="font-nastaleeqKasheeda text-md sm:text-md md:text-lg lg:text-xl text-end">
                    جیسا کہ آپ دیکھ رہے ہیں، تو کیوں نہ اسے اپنے دوستوں کے ساتھ
                    بھی شیئر کریں۔
                  </p>
                  <div dir="ltr">
                    <SocialHandles
                      handleCopyArticle={handleCopyArticle}
                      isArticle={true}
                    />
                    {copyStatus && (
                      <p
                        className={`text-sm ${copyStatus.includes("ناکامی") ? "text-red-500" : "text-black"}`}
                      >
                        {copyStatus}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Related Articles Section */}
          {Array.isArray(relatedArticles) && relatedArticles.length > 0 && (
            <div className="text-right flex flex-col mt-8">
              <p className="text-2xl lg:text-[32px] mb-5">متعلقہ مضامین</p>
              <div className="flex flex-col lg:flex-row gap-6">
                {relatedArticles.map((related, index) => (
                  <button
                    key={index}
                    className="p-3 w-full lg:w-1/3 rounded-[10px] bg-[#F8F8F8] flex flex-col gap-[10px]"
                    onClick={() => handleViewDetail(related.id)}
                  >
                    <div className="flex flex-row gap-1 bg-white rounded-[20px] p-[5px] pl-3 w-fit items-center">
                      <span className="rounded-full h-4 w-4 bg-primary"></span>
                      <p className="font-nastaleeqKasheeda text-primary text-sm">
                        {related.category}
                      </p>
                    </div>
                    <p className="text-md sm:text-md md:text-lg lg:text-lg px-3 font-nastaleeqKasheeda">
                      {related.title}
                    </p>
                    <ul className="flex list-disc p-3 justify-center">
                      <li className="ml-6 font-nastaleeqRegular">
                        {related.read_min} منٹ پڑھنے کا وقت
                      </li>
                      <li className="font-nastaleeqRegular">
                        {article.article_type}-{article?.yearData?.year}
                      </li>
                    </ul>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArticleTableeghat;
